// extracted by mini-css-extract-plugin
export var collapsedSummary = "_qy-0";